<template>
  <v-navigation-drawer
    v-model="inputValue"
    id="app-drawer"
    app
    dark
    floating
    persistent
    mobile-breakpoint="991"
    class="drawer-bg"
    width="180"
    :permanent="responsive"
    :touchless="true"
  >
    <v-img :src="image" height="100%" v-if="!checkCustomInstitute()">
      <v-layout class="fill-height rmflex" tag="v-list" column>
        <v-list-item-title
          @click="onClickLogo"
          class="text-logo menu-list-logo"
          :class="{ 'disable-click': isTestStarted }"
        >
          <div class="link-logo zerokelvin">
            <v-img
              class="text-logo-img"
              :src="logo"
              height="64"
              width="180"
              contain
            />
          </div>
        </v-list-item-title>
        <div
          v-if="
            user &&
              (user.role_id === roleIds.CO ||
                user.role_id === roleIds.ID ||
                user.role_id === roleIds.ED ||
                user.role_id === roleIds.TR)
          "
          class="student-approved"
        >
          <div clas="menu-head-sub">
            <v-carousel cycle height="70" show-arrows-on-hover hide-delimiters>
              <v-carousel-item v-for="(slide, i) in slides" :key="i">
                <v-row class="fill-height" align="center" justify="center">
                  <div class="text">
                    <div class="slide-text">
                      {{
                        slide == "Active students"
                          ? user.total_active_student
                            ? user.total_active_student
                            : 0
                          : ""
                      }}
                    </div>
                    <div class="slide-text-text">
                      {{ slide == "Active students" ? "Active students" : "" }}
                    </div>
                  </div>
                  <div class="text">
                    <div class="slide-text">
                      {{
                        slide == "Deactivated students"
                          ? user.total_deactive_student
                            ? user.total_deactive_student
                            : 0
                          : ""
                      }}
                    </div>
                    <div class="slide-text-text">
                      {{
                        slide == "Deactivated students"
                          ? "Deactivated students"
                          : ""
                      }}
                    </div>
                  </div>
                  <div class="text">
                    <div class="slide-text">
                      {{
                        slide == "Unused Licenses"
                          ? user.student_remaining_licenses
                            ? user.student_remaining_licenses
                            : 0
                          : ""
                      }}
                    </div>
                    <div class="slide-text-text">
                      {{ slide == "Unused Licenses" ? "Unused Licenses" : "" }}
                    </div>
                  </div>
                  <div class="text">
                    <div class="slide-text">
                      {{
                        slide == "Days to Renewal"
                          ? display_expiry_date
                            ? display_expiry_date
                            : 0
                          : ""
                      }}
                    </div>
                    <div class="slide-text-text">
                      {{ slide == "Days to Renewal" ? "Days to Renewal" : "" }}
                    </div>
                  </div>
                </v-row>
              </v-carousel-item>
            </v-carousel>
          </div>
        </div>
        <!-- <div
          v-else-if="showUpgradeButton && !isAltitudeInstitute()"
          class="student-approved"
        >
          <div @click="goToPackages" class="menu-head-sub">
            <v-btn color="default" class="upgrade-btn">
              <img
                src="../../assets/img/svg/upgradewhite.svg"
                class="shop-more"
              />
              <span>Upgrade</span>
            </v-btn>
          </div> -->
          <!-- <div
            v-if="user && showMore && !isAltitudeInstitute()"
            @click="goToPackages"
            class="menu-head-sub"
          >
            <v-btn color="default" class="upgrade-btn">
              <img
                src="../../assets/img/svg/upgradewhite.svg"
                class="shop-more"
              />
              <span>Upgrade</span>
            </v-btn>
          </div> -->
        </div>
        <div class="student-approved" v-else>
          <!-- <div class="menu-head-sub">
            <v-btn
              color="default"
              class="upgrade-btn"
              @click="goToPackages()"
              v-if="!isAltitudeInstitute()"
            >
              <img
                src="../../assets/img/svg/upgradewhite.svg"
                class="shop-more"
              />
              <span>Upgrade</span>
            </v-btn>
          </div> -->
        </div>
        <div class="dense-menulist">
          <v-list dense>
            <v-list-item-group v-model="selectedMenuPos" color="primary">
              <v-list-item
                active-class="v-item--active"
                :class="
                  item.sub_pages && item.sub_pages.indexOf($route.name) !== -1
                    ? 'v-item--active'
                    : ''
                "
                :to="{
                  name: item.toRoute,
                  params: { resetPage: true }
                }"
                class="list-item-menu"
                v-for="(item, i) in menuList.sub_menus"
                :key="i"
                v-if="!item.hideFromDrawer"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <div class="terms-list">
            <div
              class="terms-list-tag"
              v-if="showPrivacyAndTerms"
              @click="termandcondition"
            >
              Terms of Service
            </div>
            <div
              class="terms-list-tag"
              v-if="showPrivacyAndTerms"
              @click="privacyPolicy"
            >
              Privacy Policy
            </div>
          </div>
        </div>
        <div class="sidebar-logo desk-hide">
          <!-- <img v-if="showPrivacyAndTerms" src="../../assets/img/Login_Page_logo.png" class="master-logo" height="64" contain /> -->

          <img class="master-logo" :src="logo" height="64" contain />
        </div>
      </v-layout>
    </v-img>
    <div class="myt-menu" v-else>
      <v-img :src="image" height="100%">
        <v-layout class="fill-height rmflex" tag="v-list" column>
          <v-list-item-title
            @click="onClickLogo"
            class="text-logo menu-list-logo "
            :class="{ 'disable-click': isTestStarted }"
          >
            <div class="link-logo">
              <v-img class="text-logo-img" :src="logo" height="64" contain />
            </div>
          </v-list-item-title>

          <div v-if="currentRoute != 'preview-myt-test'" class="dense-menulist">
            <!-- <div
          v-for="(menu, index) in menus"
          :key="index"
          v-if="!menu.hideFromTop"
          class="menu-block"
          @click="onMenuClick(menu)"
          :disabled="buttonHovering == index || selectedMenu.css === menu.css"
          v-on:mouseover="onMouserHover(menu, index)"
          v-on:mouseleave="buttonHovering = -1"
        >
          <div
            v-if="buttonHovering === index"
            class="v-tooltip__content cust-new-tooltip-bottom open-bottom"
            style="opacity: 0;top: auto;z-index: 9999;bottom:0"
          >
            <div>
              {{ menu.label }}
            </div>
          </div>

          <div :class="getCSS(menu.css)">
            <img :src="menu.icon" />
          </div>
          <div class="menu-name">
            {{ selectedMenu.css === menu.css ? menu.label : "&nbsp;" }}
          </div>
        </div> -->
            <v-list dense>
              <v-list-item-group v-model="selectedMenuPos" color="primary">
                <v-list-item
                  active-class="v-item--active"
                  :class="
                    item.sub_pages && item.sub_pages.indexOf($route.name) !== -1
                      ? 'v-item--active'
                      : ''
                  "
                  :to="{
                    name: item.toRoute,
                    params: { resetPage: true }
                  }"
                  class="list-item-menu"
                  v-for="(item, i) in menuList"
                  :key="i"
                  v-if="!item.hideFromDrawer"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>
          <div class="sidebar-logo desk-hide myt-logo">
            <img class="master-logo" :src="logo" height="64" contain />
          </div>
        </v-layout>
      </v-img>
    </div>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState, mapActions } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";
import menuList from "../../utils/menu";

import VueCookies from "vue-cookies";
export default {
  data() {
    return {
      selectedMenuPos: 0,
      logo: this.getInstituteLogo(),
      responsive: false,
      menuList: [],
      showMore: false,
      currentRoute: "",
      logo: "",
      title: 1,
      slides: [
        "Active students",
        "Deactivated students",
        "Unused Licenses",
        "Days to Renewal"
      ],
      showUpgradeButton: true,
      modules: [],
      subscription_data: {},
      allowed_end_date: "",
      last_date: "",
      expiration_date: "",
      display_expiry_date: "",
      unused_licenses: "",
      showPrivacyAndTerms: true
    };
  },
  computed: {
    ...mapState("app", ["color", "image", "selectedMenu"]),
    ...mapState("userStore", ["user", "myInstitute"]),
    ...mapState("testStore", ["isTestStarted"]),

    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    }
  },

  async mounted() {
    this.currentRoute = this.$route.name;
    this.menuList = this.selectedMenu || [];
    let isWebsiteUser = JSON.parse(this.$cookies.get('websiteUser'));
    let userToken = JSON.parse(this.$cookies.get('userToken'));
    let auth_token = sessionStorage.getItem("auth_token");
    let keepMeLoggedIn = JSON.parse(this.$cookies.get('keepMeLoggedIn'));
    if ((this.myInstitute.id === constants.ONLINE_INSTITUTE_ID) && isWebsiteUser && userToken && (auth_token != userToken)){
      await this.loginWebsite(userToken,keepMeLoggedIn);
      await this.delayTime(500);
    }
    this.$cookies.remove('websiteUser',this.COOKIE_PATH,this.COOKIE_DOMAIN);
    if (!this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id)) {
      this.getModules();
      this.me();
      this.getPackagesList();
    }else{
      this.menuList = this.checkMenuList();
      if (!localStorage.getItem('guest_user_id') ) {
        localStorage.setItem('guest_user_id','temp'+moment().format('X'))
      }
    }
    //this.updateMenuList(this.menuList);
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
    this.logo = this.getInstituteLogo();
    this.showUpgradeButton = this.checkIsDefaultInstitute();
    this.getInstituteDetails();
    if (localStorage.getItem("myInstitute")) {
      this.subscription_data = JSON.parse(localStorage.getItem("myInstitute"));
      this.allowed_end_date = moment(
        `${this.subscription_data.expiry_date}`
      ).format("DD - MMM - YYYY");
      this.showPrivacyAndTerms = !constants.CUSTOM_DOMAIN_ID.includes(
        this.subscription_data.id
      );
    }
    this.last_date = moment();
    this.expiration_date = moment(this.subscription_data.expiry_date);
    this.display_expiry_date = this.expiration_date.diff(
      this.last_date,
      "days"
    );
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    ...mapActions({
      getPackages: "userStore/getPackages",
      getUserPurchasedModules: "userStore/getUserPurchasedModules",
      getInstituteDetails: "userStore/getInstituteDetails",
      me: "userStore/me",
      logIn: "userStore/logIn",
    }),
    termandcondition() {
      let routeData = this.$router.resolve({ name: "terms-and-conditions" });
      window.open(routeData.href, "_blank");
    },
    privacyPolicy() {
      let routeData = this.$router.resolve({ name: "privacy-policy" });
      window.open(routeData.href, "_blank");
    },
    checkMenuList(){
      if(this.user && this.user.id){
          return menuList.MENU.CUSTOMMENU
        }
        else{
          let menu=menuList.MENU.CUSTOMMENU;
          let updatedMenu = []
          for (const key in menu) {
            if (menu.hasOwnProperty(key) && menu[key].id !== "MY-TEMPLATE") {
               updatedMenu[key] = menu[key];
             }
          }
          return updatedMenu
        }
    },
    getPackagesList() {
      //   //this.$root.showLoader = true;
      this.getPackages({})
        .then((response) => {
          //   //this.$root.showLoader = false;
          let purchaseCount = 0;
          let totalPackages = response.length;
          response.map((pkg) => {
            if (pkg.is_purchased) purchaseCount++;
          });
          if (purchaseCount == totalPackages) {
            this.showMore = false;
          } else {
            this.showMore = true;
          }
        })
        .catch((err) => {
          //   //this.$root.showLoader = false;
        });
    },
    loginWebsite(token,keepMeLoggedIn){
      return new Promise((resolve, reject) => {
            let reqData = {
                token:  token,
                external:true,
                keepMeLoggedIn: keepMeLoggedIn

            }
            this.$root.showLoader = true;
            this.isLoading = true
            this.logIn(reqData)
            .then(response=>{
                if(response){
                    sessionStorage.setItem(
                        "onPopUpFeedBackModal",
                        true
                    );
                }
                if (!response.telegram_id && !this.isZeroKelvinInstitute()) {
                    sessionStorage.setItem(
                        "showVerifyTelegramBox",
                        true
                    )
                }
                let product = this.$cookies.get('upgrade');

                if (response.institute ===this.ONLINE_INSTITUTE_ID ) {
                    if (product) {
                        this.$router.push({name:"my-subscription",query:{productId:product}})     
                    }else{
                        this.$router.push({name:"home"})
                    }
                }
                this.$root.showLoader = false;
                this.isLoading = false;
                resolve(response);
            })
            .catch(err=>{
                this.$root.showLoader = false;
                this.isLoading = false;
                reject(err);

            });
          });
        },
    getText(item) {
      // for showing no of unread inbox messages
      let text = item.text;
      if (item.type && item.type == "inbox") {
        return text + "(10)";
      }
      return text;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = false;
      } else {
        this.responsive = true;
      }
    },
    goToPackages() {
      this.$router.push({ name: "my-subscription" });
    },
    updateMenuList(val) {
      /*val.sub_menus = val.sub_menus.filter((xx) => {
        return (
          !xx.requireGold ||
          (xx.requireGold && this.myInstitute.type === this.types.GOLD)
        );
      });*/

      this.menuList = val;
      if (
        this.checkCustomInstitute()
      ) {
        this.menuList =  this.checkMenuList()
      }
    },
    getModules() {
      let userCookie = VueCookies.get("userDetails");
      let userId =
        this.user && this.user.id
          ? this.user.id
          : userCookie && userCookie.user && userCookie.user.id
          ? userCookie.user.id
          : null;

      const reqData = {
        userId: userId
      };
      this.getUserPurchasedModules(reqData)
        .then((response) => {
          this.modules = response;
          localStorage.setItem("modules", JSON.stringify(this.modules));
        })
        .catch((err) => {
          console.log(err);
        });
      let product = this.$cookies.get("upgrade");
      if (product) {
        this.$router.push({
          name: "my-subscription",
          query: { productId: product }
        });
      }
    },
    // UpdateTestMenuList(val) {
    //   if (this.modules.length <= 0) {
    //     this.modules = JSON.parse(localStorage.getItem("modules"));
    //   }
    //   val.sub_menus.map((m) => {
    //     for (let i = 0; i < this.modules.length; i++) {
    //       if (
    //         (m.id === this.modules[i].module_id ||
    //           m.id === this.modules[i].parent_module_id) &&
    //         this.modules[i].is_selected === 1
    //       ) {
    //         m.hideFromDrawer = false;
    //         m.hideFromBreadCrumb = false;
    //         m.hideFromDashBoard = false;
    //       }
    //     }
    //   });
    //   this.menuList = val;
    // },
    onClickLogo() {
      if (this.myInstitute.id === constants.ONLINE_INSTITUTE_ID) {
        // this.$cookies.set(
        //   "userToken",
        //   JSON.stringify(sessionStorage.getItem("auth_token"))
        // );
        window.location.href = process.env.VUE_APP_REDIRECT_LOGIN_URL;
      } else {
        this.$router.push({ name: "home" }).catch(() => {});
      }
    },

    checkCustomInstitute() {
      return this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id);
    }
  },
  watch: {
    selectedMenu(val) {
      this.updateMenuList(val);
    },
    myInstitute(val) {
      this.updateMenuList(this.menuList);
    },
    user(val) {
      if(this.checkCustomInstitute()){
        if (val && val.id) {
         this.updateMenuList()
        }
        else{
         this.updateMenuList()
        }
      }
    }
  }
};
</script>

<style lang="scss">
#app-drawer {
  .v-list__tile {
    border-radius: 4px;
    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }
  // .v-image__image--contain {
  //     top: 6px;
  //     height: 80%;
  // }
  .search-input {
    margin-bottom: 30px !important;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
